<!--<div class="language-button">-->
<!--  <button mat-icon-button [matMenuTriggerFor]="languageMenu">-->
<!--    <span style="font-weight: bold;font-size: 15px" *ngIf="_translate.currentLang === 'ar'"-->
<!--      >AR</span-->
<!--    >-->
<!--    <span style="font-weight: bold;font-size: 15px" *ngIf="_translate.currentLang === 'en'"-->
<!--      >EN</span-->
<!--    >-->
<!--  </button>-->

<!--</div>-->



<button style="margin: 0 " mat-mini-fab color="inherit" [matMenuTriggerFor]="languageMenu"   #menuTrigger="matMenuTrigger"
  class="d-flex justify-content-center">


  @if (_translate.currentLang === 'ar') {
<!--    <span style="padding: 0 4px" class="f-w-600">AR</span>-->
    <img alt="ar" style="max-width: 20px;" src="./assets/images/login/ar.png" />

  } @else if (_translate.currentLang === 'en') {
<!--    <span style="padding: 0 4px" class="f-w-600">EN</span>-->
    <img alt="ar" style="max-width: 20px;" src="./assets/images/login/en.png" />

  } @else if (_translate.currentLang === 'fr') {
<!--    <span style="padding: 0 4px" class="f-w-600">FR</span>-->
    <img alt="ar" style="max-width: 20px;" src="./assets/images/login/fr.png" />
  } @else if (_translate.currentLang === 'es') {
<!--    <span style="padding: 0 4px" class="f-w-600">ES</span>-->
    <img alt="ar" style="max-width: 30px;" src="./assets/images/login/es.png" />
  }

<!--  @if (_translate.currentLang === 'ar') {-->
<!--  <span class="f-w-600">Ar</span>-->
<!--  &lt;!&ndash;    <i&ndash;&gt;-->
<!--  &lt;!&ndash;      class="iconify icon-24 d-flex"&ndash;&gt;-->
<!--  &lt;!&ndash;      data-icon="twemoji:flag-saudi-arabia"&ndash;&gt;-->
<!--  &lt;!&ndash;    ></i>&ndash;&gt;-->
<!--  } @else {-->

<!--  <span class="f-w-600">En</span>-->
<!--  }-->
</button>
<mat-menu #languageMenu="matMenu">
  <button *ngIf="_translate.currentLang !== 'ar'" mat-menu-item (click)="changeLanguage('ar')">
    <span style="margin-left: 20px; font-weight: bold ; padding: 0 4px">AR</span>
    <img alt="ar" style="max-width: 20px;" src="./assets/images/login/ar.png" />
  </button>
  <button  *ngIf="_translate.currentLang !== 'en'" mat-menu-item (click)="changeLanguage('en')">
    <span  [ngStyle]="['en', 'fr', 'es'].includes(_translate.currentLang)
    ? {'margin-left': '20px'}
    : {'margin-right': '20px'}"  style=" font-weight: bold ; padding: 0 4px">EN</span>
    <img alt="ar" style="max-width: 20px;" src="./assets/images/login/en.png" />
  </button>
  <button  *ngIf="_translate.currentLang !== 'fr'" mat-menu-item (click)="changeLanguage('fr')">
    <span [ngStyle]="['en', 'fr', 'es'].includes(_translate.currentLang)
    ? {'margin-left': '20px'}
    : {'margin-right': '20px'}" style=" font-weight: bold ; padding: 0 4px">FR</span>
    <img alt="ar" style="max-width: 20px;" src="./assets/images/login/fr.png" />
  </button>
  <button *ngIf="_translate.currentLang !== 'es'" mat-menu-item (click)="changeLanguage('es')">
    <span [ngStyle]="['en', 'fr', 'es'].includes(_translate.currentLang)
    ? {'margin-left': '20px'}
    : {'margin-right': '20px'}"      style=" font-weight: bold ; padding: 0 4px">ES</span>  <img alt="ar" style="max-width: 30px;" src="./assets/images/login/es.png" />
  </button>
</mat-menu>
